import React, { useState } from "react"
import axios from "axios"
import { navigate } from "gatsby"
import scrollToElement from "scroll-to-element"

import { useLocale } from "context/locale"

import Input from "components/Input"
import Checkbox from "components/Checkbox"
import Button from "components/Button"

const PartnershipForm = () => {
  const { lang, t } = useLocale()

  const formID = "2003"

  const [input, setInput] = useState({
    send: false,
    name: "",
    lastName: "",
    email: "",
    phone: "",
    country: "",
    message: "",
    legalPartnership: false,
    legalPrivacy: false,
  })

  const [validationErrors, setValidationErrors] = useState({
    name: "",
    lastName: "",
    email: "",
    phone: "",
    country: "",
    message: "",
    legalPartnership: "",
    legalPrivacy: "",
  })

  const handleValidation = () => {
    const schema = {
      name: input.name.length <= 2 ? "error" : "",
      lastName: input.lastName.length <= 2 ? "error" : "",
      email: input.email.length <= 2 ? "error" : "",
      phone: input.phone.length <= 2 ? "error" : "",
      country: input.country.length <= 2 ? "error" : "",
      message: input.message.length <= 2 ? "error" : "",
      legalPartnership: !input.legalPartnership ? "error" : "",
      legalPrivacy: !input.legalPrivacy ? "error" : "",
    }

    setValidationErrors({
      ...validationErrors,
      ...schema,
    })

    return !Object.values({ ...validationErrors, ...schema }).includes("error")
  }

  const formSubmit = e => {
    e.preventDefault()

    if (!handleValidation()) {
      scrollToElement("#formTop", { duration: 200 })
    } else {
      setInput({ ...input, send: true })

      let formData = new FormData()

      formData.set("firstName", input.name)
      formData.set("lastName", input.lastName)
      formData.set("email", input.email)
      formData.set("phone", input.phone)
      formData.set("country", input.country)
      formData.set("message", input.message)
      formData.set("legalPartnership", input.legalPartnership)
      formData.set("legalPrivacy", input.legalPrivacy)

      axios({
        method: "post",
        url: `https://webinity.zenx.pl/wp-json/contact-form-7/v1/contact-forms/${formID}/feedback/`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(() => {
          navigate(t("/contact-confirmation/"))
        })
        .catch(() => {
          setInput({ ...input, send: false })
        })
    }
  }

  return (
    <form className="form partnership-content__edge">
      <div className="partnership-content__content">
        <h2>{t("Join our partnership program")}</h2>
        <p className="partnership-content__description">
          {t("Fill the form below to become our partner")}
        </p>

        <div className="partnership-content__steps">
          <Input
            label={t("Name")}
            placeholder={t("John")}
            type="text"
            id="name"
            name="name"
            value={input.name}
            onChange={e => setInput({ ...input, name: e.target.value })}
            error={validationErrors.name}
            errorMsg={t("Required field")}
            required
          />
          <Input
            label={t("Surname")}
            placeholder={t("Doe")}
            type="text"
            id="lastName"
            name="lastName"
            value={input.lastName}
            onChange={e => setInput({ ...input, lastName: e.target.value })}
            error={validationErrors.lastName}
            errorMsg={t("Required field")}
            required
          />
          <Input
            label={t("Email")}
            placeholder={t("john.doe@example.com")}
            type="email"
            id="email"
            name="email"
            value={input.email}
            onChange={e => setInput({ ...input, email: e.target.value })}
            error={validationErrors.email}
            errorMsg={t("Required field")}
            required
          />
          <Input
            label={t("Phone")}
            placeholder="123-123-123"
            type="tel"
            id="phone"
            name="phone"
            value={input.phone}
            onChange={e => setInput({ ...input, phone: e.target.value })}
            error={validationErrors.phone}
            errorMsg={t("Required field")}
            required
          />
          <Input
            label={t("Country")}
            placeholder={lang === "pl" ? "Polska" : "United States of America"}
            type="text"
            id="country"
            name="country"
            value={input.country}
            onChange={e => setInput({ ...input, country: e.target.value })}
            error={validationErrors.country}
            errorMsg={t("Required field")}
            required
          />
          <Input
            label={t("Message")}
            placeholder={t("Type your message here...")}
            type="textarea"
            id="message"
            name="message"
            value={input.message}
            onChange={e => setInput({ ...input, message: e.target.value })}
            error={validationErrors.message}
            errorMsg={t("Required field")}
            rows="6"
            required
          />
          <Checkbox
            name="legalPartnership"
            checked={input.legalPartnership}
            onChange={() =>
              setInput({ ...input, legalPartnership: !input.legalPartnership })
            }
            error={validationErrors.legalPartnership}
            required
          >
            <span>*</span>
            <div
              dangerouslySetInnerHTML={{
                __html: t(
                  "I accept terms and conditions of the <a href='https://webinity.zenx.pl/wp-content/uploads/2023/11/Partnership-Agreement-Webinity.pdf' download target='_blank' rel='noopener'>Partnership Agreement.</a>"
                ),
              }}
            />
          </Checkbox>
          <Checkbox
            name="legalPrivacy"
            checked={input.legalPrivacy}
            onChange={() =>
              setInput({ ...input, legalPrivacy: !input.legalPrivacy })
            }
            error={validationErrors.legalPrivacy}
            required
          >
            <span>*</span>
            <div
              dangerouslySetInnerHTML={{
                __html: t(
                  "I accept Webinity's <a href='/privacy-policy/'>Privacy Policy</a> and understand that providing the data indicated in the form is voluntary and required to receive an answer to my inquiry."
                ),
              }}
            />
          </Checkbox>
          <p className="form__info">
            <span>*</span> {t("Required field").toLowerCase()}
          </p>
        </div>
      </div>
      <div className="partnership-content__submit">
        <Button
          className="button--small button--blue"
          type="button"
          disabled={
            !input.legalPartnership || !input.legalPrivacy || input.send
          }
          onClick={formSubmit}
        >
          {input.send === true ? t("Sending...") : t("Send message")}
        </Button>
      </div>
    </form>
  )
}

export default PartnershipForm
